import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { format } from 'date-fns';

import ru from 'date-fns/locale/ru';
import enUS from 'date-fns/locale/en-US';

const DATE_LOCALES = {
  ru,
  en: enUS,
};

const DATE_FORMATS = {
  date_ru: 'dd.MM.y',
  date_en: 'dd/MM/y',
  datetime_short_ru: 'dd.MM.y H:mm',
  datetime_short_en: 'dd/MM/y h:mm a',
  datetime_long_ru: 'dd.MM.y H:mm:ss',
  datetime_long_en: 'dd/MM/y h:mm:ss a',
};

const NUMBER_ABBR = ['', 'k', 'm'];

const abbreviateNumber = number => {
  // what tier? (determines SI symbol)
  const tier = (Math.log10(number) / 3) | 0;
  // if zero, we don't need a suffix
  if (tier === 0) return number;
  // get suffix and determine scale
  const suffix = NUMBER_ABBR[tier];
  const scale = Math.pow(10, tier * 3);
  // scale the number
  const scaled = number / scale;
  // format number and add suffix
  return scaled.toFixed(1) + suffix;
};

const initI18n = resources => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      detection: {
        // order and from where user language should be detected
        order: ['localStorage', 'navigator'],

        // keys or params to lookup language from
        lookupLocalStorage: 'i18nextLng',

        // cache user language on
        caches: ['localStorage'],
        excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
      },
      debug: false,
      nsSeparator: false,
      keySeparator: false,
      fallbackLng: false,
      load: 'languageOnly',

      interpolation: {
        escapeValue: false,
        format: function(value, fmt) {
          const lng = i18n.languages[0];
          if (value instanceof Date)
            return format(value, DATE_FORMATS[`${fmt}_${lng}`], { awareOfUnicodeTokens: true });

          if (!isNaN(value) && fmt === 'number') return value.toLocaleString(lng);
          if (!isNaN(value) && fmt === 'number_abbr') return abbreviateNumber(value);

          if (!isNaN(value) && fmt === 'currency') return new Intl.NumberFormat({ style: 'currency' }).format(value);

          return value;
        },
      },
      resources,
    });
  return i18n;
};

const getDateLocale = lng => DATE_LOCALES[lng] || enUS;

export { getDateLocale, initI18n };
